import round from "lodash-es/round";
import classNames from "classnames";
import "./styles.scss";
import { TopicWithScore } from "@/routes/Frontend/FuturebilityCockpit/hooks";

interface TopicScoreProps {
  topic: TopicWithScore;
  isSelected?: boolean;
  onClick?: (topicId: string) => void;
}

const TopicScore = ({
  topic: { info, category, score, benchmark, _id },
  isSelected,
  onClick,
}: TopicScoreProps) => {
  return (
    <div
      className={classNames("topic-score", { "is-selected": isSelected })}
      onClick={() => onClick?.(_id)}
    >
      <div className="topic-left">
        <div className="topic-title">{info.name}</div>
        <div className="topic-sub">
          <div className={`shape ${category}`} aria-label={category}></div>
          <div>
            Score <span className="highlight">{round(score, 0)}%</span> vs
            Benchmark <span className="highlight">{benchmark}%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopicScore;
